import { PREVIEW, PREVIEW_SIMULTANEOUS_REC } from "../../constants";
import { getCurrentTimeInSec } from "../../js/helpers/Utils/formats";

export function incrementDiscardedRegisters() {
    return {
      type: PREVIEW.INCREMENT_DISCARDED,
    };
  }
export function savePreviewRecord (record) {
    return {
      type:PREVIEW.SET_PREVIEW_RECORD ,
      payload: record,
  };
}
export function updatePreviewRecord (record) {
  return {
      type:PREVIEW.UPDATE_PREVIEW_RECORD ,
      payload: record,
  };
}
export function updatePreviewTime(time) {
  return{
    type: PREVIEW.UPDATE_PREVIEWTIME,
    payload: time,
  }
}
export function setTempData(tempData){
  return{
    type: PREVIEW.SET_TEMP_DATA,
    payload: tempData
  }
}
export function cleanData(){
  return{
    type: PREVIEW.CLEAN_DATA
  }
}
export function setPhoneToCall(phone){
  return{
    type: PREVIEW.SET_PHONE_CALL,
    payload: phone
  }
}
export function changeCampaignType(flag){
  return{
    type: PREVIEW.CHANGE_CAMPAIGN_TYPE,
    payload:flag
  }
}
export function isSuccessfullChangeCamp(change){
  return{
    type: PREVIEW.SUCCESSFUL_CHANGE,
    payload:change
  }
}
export function setIsRunningClock(flag){
  return{
    type: PREVIEW.SET_ISRUNNING_CLOCK ,
    payload:flag
  }
}
export function setNewPreviewTime(time){
  return{
    type: PREVIEW.SET_NEWPREVIEW_TIME,
    payload:time
  }
}
export function saveTotalPreviewTime(time){
  return{
    type: PREVIEW.SET_FINAL_TIME,
    payload:time
  }
}
export function saveInitialTime(){
  let time = getCurrentTimeInSec();
  return{
    type: PREVIEW.SET_INITIAL_TIME,
    payload:time
  }
}
export function saveDataFromTransfer(data){
  return{
    type: PREVIEW.SET_DATA_TRANSFER,
    payload:data
  }
}
export function setDialogTime(data){
  return{
    type: PREVIEW.SET_DIALOG_TIME,
    payload:data
  }
}
export function setDialingMode(data){
  return{
    type: PREVIEW.SET_DIALINGMODE,
    payload:data
  }
}
export function setIsSendProcess(data){
  return{
    type: PREVIEW.SET_IS_SEND_PROCESS,
    payload:data
  }
}
export function setTempPrevRecord(data){
  return{
    type: PREVIEW.SET_TEMP_PREVIEW_RECORD,
    payload:data
  }
}
export function setPreviewSelectedCampaign(data){
  return{
    type: PREVIEW.SELECTED_PREVIEW_CAMPAIGN,
    payload:data
  }
}
export function saveTotalTimePerRec(data){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.SET_TOTAL_TIME,
    payload: data
  }
}
export function setPhoneToCallPerRec(data){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.SET_PHONE_TO_CALL,
    payload:data
  }
}
export function removeRecord(data){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.REMOVE_RECORD,
    payload: data//
  }
}
export function saveLogDial(data){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.SAVE_LOG_DIAL,
    payload: data
  }
}
export function setItSimultaneousView(data){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.SET_INITIAL_TIMESEC,
    payload: data
  }
}
export function changePreviewRecordStatus(payload){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.CHANGE_RECORD_STATE,
    payload: payload
  }
}
export function setInitialDialogTime(payload){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.SET_INITIAL_DIALOG_TIME,
    payload: payload
  }
}
export function setSelectedRecord(payload){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.SELECTED_RECORD,
    payload: payload
  }
}
export function resetRecordPreview(payload){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.RESET_RECORD,
    payload: payload
  }
}
export function setCallId(payload){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.SET_CALL_ID,
    payload: payload
  }
}
export function setDialogTimeSimultaneousView(payload){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.SET_DIALOG_TIME,
    payload: payload
  }
}
export function setMaximumAssignmentPreview(payload){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.SET_MAXIMUM_ASSIGNMENTS,
    payload: payload
  }
}
export function setWasItwasSentPreviewTime(payload){
  return{
    type:PREVIEW_SIMULTANEOUS_REC.SET_IT_WAS_SENT_TIME,
    payload:payload
  }
}
export function setVolume(payload){
  return{
    type:PREVIEW_SIMULTANEOUS_REC.SET_VOLUME,
    payload:payload
  }
}
export function setMarks(payload){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.SET_MARKS,
    payload:payload
  }
}

export function setDispositionData(payload){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.SET_DISPOSITION_DATA,
    payload:payload
  }
}

export function setNDScheduled(){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.SET_ND_SCHEDULED
  }
}

export function setFlagLogDial(payload){
  return{
    type: PREVIEW_SIMULTANEOUS_REC.SET_FLAG_LOGDIAL,
    payload:payload
  }
}




// WEBPACK FOOTER //
// ./src/redux/actions/A_preview.js